import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import FeaturedVideos from './components/FeaturedVideos';
import TrendingVideos from './components/TrendingVideos';
import CreatorShowcase from './components/CreatorShowcase';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import HomeSEO from './components/HomeSEO';

export default function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <HomeSEO />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryNav />
        <FeaturedVideos />
        <TrendingVideos />
        <CreatorShowcase />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}